document.addEventListener('DOMContentLoaded',function(){
  var root=document.querySelector('.wm-product-page');
  if(!root)return;
  var logoUrl=document.body.getAttribute('data-wm-product-logo');
  var videoItems=Array.from(root.querySelectorAll('.wm-product-media-item')).filter(function(item){return item.querySelector('video')});
  if(!videoItems.length)return;

  videoItems.forEach(function(item){
    var video=item.querySelector('video');
    var wasActive=false;
    item.classList.add('wm-product-media-item--video');
    video.autoplay=false;
    video.loop=false;
    video.muted=true;
    video.defaultMuted=true;
    video.playsInline=true;
    video.controls=false;
    video.removeAttribute('autoplay');
    video.removeAttribute('loop');
    video.setAttribute('muted','');
    video.setAttribute('playsinline','');
    video.removeAttribute('controls');

    var soundButton=document.createElement('button');
    soundButton.type='button';
    soundButton.className='wm-product-video-sound';
    function syncSound(){
      var soundEnabled=!video.muted&&video.volume>0;
      soundButton.innerHTML='<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M11 5 6 9H3v6h3l5 4V5Z"/>'+(soundEnabled?'<path d="M15 8a6 6 0 0 1 0 8M18 5a10 10 0 0 1 0 14"/>':'<path d="m16 9 6 6m0-6-6 6"/>')+'</svg>';
      soundButton.setAttribute('aria-label',soundEnabled?'Mute video sound':'Enable video sound');
      soundButton.setAttribute('aria-pressed',String(soundEnabled));
    }
    soundButton.addEventListener('click',function(event){
      event.stopPropagation();
      video.muted=!video.muted&&video.volume>0;
      if(!video.muted&&video.volume===0)video.volume=1;
      syncSound();
      if(video.paused){
        var playPromise=video.play();
        if(playPromise&&typeof playPromise.catch==='function')playPromise.catch(function(){});
      }
    });
    video.addEventListener('volumechange',syncSound);
    syncSound();
    item.appendChild(soundButton);

    if(logoUrl&&!item.querySelector('.wm-product-video-logo')){
      var logoWrap=document.createElement('div');
      logoWrap.className='wm-product-video-logo';
      var logo=document.createElement('img');
      logo.src=logoUrl;
      logo.alt='';
      logo.loading='lazy';
      logoWrap.appendChild(logo);
      var caption=document.createElement('p');
      caption.className='wm-product-video-caption';
      caption.textContent='Wear a little wonder.';
      logoWrap.appendChild(caption);
      item.appendChild(logoWrap);
    }

    function syncPlayback(){
      var isActive=item.classList.contains('is-active');
      if(isActive&&!wasActive){
        video.currentTime=0;
        var playPromise=video.play();
        if(playPromise&&typeof playPromise.catch==='function')playPromise.catch(function(){});
      }else if(!isActive){
        video.pause();
        video.currentTime=0;
      }
      wasActive=isActive;
    }
    new MutationObserver(syncPlayback).observe(item,{attributes:true,attributeFilter:['class']});
    syncPlayback();
  });
});
